import React, { Component } from "react";
import hairCut from "./images/men.jpg";
import beardTrim from "./images/beardTrim.jpg";
import childHairCut from "./images/kids.jpg";
import womenHairCut from "./images/women.jpg";
import studentHairCut from "./images/student.jpg";
import './index.css'
import { withTranslation } from "react-i18next";

class Price extends Component {
  render() {
    const { t } = this.props;
    return (
      <div className="Services">
        <section className="page-section bg-light" id="services">
          <div className="container">
            <div className="row">
              <div className="col-lg-12 text-center">
                <h2 className="section-heading text-uppercase">{t("priceList.title")}</h2>
                <h3 className="section-subheading text-muted">
                {t("priceList.info")}
                </h3>
              </div>
            </div>
            <div className="row text-center justify-content-center">
                <div className="col-xl col-lg-4 col-md-4 col-6 mb-4">
                  <div className="card h-100">
                    <a href="/">
                      <img
                        className="card-img-top"
                        src={hairCut}
                        alt="menhaircut"
                      />
                    </a>
                    <div className="card-body p-2">
                      <p className="card-title mb-1" style={{fontSize: 'clamp(0.75rem, 1.2vw, 1rem)', fontWeight: 700}}>
                        {t("priceList.men")}
                      </p>
                      <p className="mb-0 text-primary" style={{fontSize: 'clamp(0.85rem, 1.4vw, 1.15rem)', fontWeight: 700}}>18€</p>
                    </div>
                  </div>
                </div>
                <div className="col-xl col-lg-4 col-md-4 col-6 mb-4">
                  <div className="card h-100">
                    <a href="/">
                      <img
                        className="card-img-top"
                        src={womenHairCut}
                        alt="womenHairCut"
                      />
                    </a>
                    <div className="card-body p-2">
                      <p className="card-title mb-1" style={{fontSize: 'clamp(0.75rem, 1.2vw, 1rem)', fontWeight: 700}}>
                        {t("priceList.women")}
                      </p>
                      <p className="mb-0 text-primary" style={{fontSize: 'clamp(0.85rem, 1.4vw, 1.15rem)', fontWeight: 700}}>25€</p>
                    </div>
                  </div>
                </div>
                <div className="col-xl col-lg-4 col-md-4 col-6 mb-4">
                  <div className="card h-100">
                    <a href="/">
                      <img
                        className="card-img-top"
                        src={childHairCut}
                        alt="childHairCut"
                      />
                    </a>
                    <div className="card-body p-2">
                      <p className="card-title mb-1" style={{fontSize: 'clamp(0.75rem, 1.2vw, 1rem)', fontWeight: 700}}>
                        {t("priceList.children")}
                      </p>
                      <p className="mb-0 text-primary" style={{fontSize: 'clamp(0.85rem, 1.4vw, 1.15rem)', fontWeight: 700}}>15€</p>
                    </div>
                  </div>
                </div>
                <div className="col-xl col-lg-4 col-md-4 col-6 mb-4">
                  <div className="card h-100">
                    <a href="/">
                      <img
                        className="card-img-top"
                        src={beardTrim}
                        alt="beardTrim"
                      />
                    </a>
                    <div className="card-body p-2">
                      <p className="card-title mb-1" style={{fontSize: 'clamp(0.75rem, 1.2vw, 1rem)', fontWeight: 700}}>
                        {t("priceList.beard")}
                      </p>
                      <p className="mb-0 text-primary" style={{fontSize: 'clamp(0.85rem, 1.4vw, 1.15rem)', fontWeight: 700}}>12€</p>
                    </div>
                  </div>
                </div>
                <div className="col-xl col-lg-4 col-md-4 col-6 mb-4">
                  <div className="card h-100">
                    <a href="/">
                      <img
                        className="card-img-top"
                        src={studentHairCut}
                        alt="studentHairCut"
                      />
                    </a>
                    <div className="card-body p-2">
                      <p className="card-title mb-1" style={{fontSize: 'clamp(0.75rem, 1.2vw, 1rem)', fontWeight: 700}}>
                        {t("priceList.student")}
                      </p>
                      <p className="mb-0 text-primary" style={{fontSize: 'clamp(0.85rem, 1.4vw, 1.15rem)', fontWeight: 700}}>15€</p>
                    </div>
                  </div>
                </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}
export default withTranslation("global")(Price);
